import styled from "styled-components";

export const Header = styled.h3`
  color: rgba(16, 15, 87, 0.49);
  font-size: 12px;
  font-weight: bold;
`;

export const UsersContainer = styled.div`
  margin: 2rem 3rem 0 3rem;
  .margin-top-container {
    margin-top: 3.2rem;
  }
`;

export const DivFormBetween = styled.div`
  .div-flex-between {
    display: flex;
    justify-content: space-between;
  }
  .create-user-div {
    color: #2e353d;
  }
  .margin-top-form {
    margin-top: 2.4rem;
  }
  .div-margin-top {
    margin-top: 3.2rem;
  }
  .div-margin-left {
    margin-left: 2rem;
  }
`;
export const DivDataUser = styled.div`
  color: #2e353d;
  font-size: 1.4rem;
  margin-top: 3.6rem;
`;

export const DivFormStyles = styled.div`
  ${(props) => `
        color: ${props.theme.colors.blackTextTitle};
        font-family: ${props.theme.fontFamilies.primaryFont};
    `}

  .inputForms {
    display: flex;
    flex-direction: column;
  }
  .inputForms label {
    font-size: 1.4rem;
  }
  .border-radio-input {
    border-radius: 2rem;
  }
  .inputForms
    .input-styles-users
    .p-multiselect-label-container
    .p-multiselect-label
    .p-multiselect-token {
    background: rgba(23, 21, 120, 0.1);
    border-radius: 8px;
  }
  .inputForms .input-styles-users {
    border-radius: 0.8rem;
    box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
    box-sizing: border-box;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-size: 1.5rem;
    font-weight: 500;
    height: 5rem;
    margin-top: 1rem;
    padding-left: 1.5rem;
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .inputForms .p-dropdown:not(.p-disabled):hover {
    border-color: #002e6c;
  }
  .inputForms .p-dropdown:not(.p-disabled).p-focus {
    border-color: #002e6c;
  }

  .inputForms .input-styles-users11 {
    align-items: center;
    border-radius: 0.8rem;
    display: flex;
    font-family: Montserrat;
    font-size: 1.4rem;
    height: 5rem;
    margin-top: 1rem;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  .inputForms .width-column-two {
    border: 1px solid #ffffff;
    width: 25.6rem;
  }
  .inputForms .p-dropdown {
    border: 1px solid #ffffff;
  }

  .inputForms .width-column-one {
    width: 34.5rem;
  }
  .inputForms .width-column-one-part {
    width: 16.4rem;
  }
  .inputForms .width-user-name {
    width: 53.2rem;
  }

  .inputForms .input-styles-users1 {
    align-items: center;
    display: flex;
    height: 5rem;
    justify-content: center;
    margin-top: 1rem;
    width: 25rem;
  }
  .inputForms .input-styles-users1 .p-dropdown-label {
    color: #08082b;
    font-size: 1.4rem;
  }
  .inputForms .p-inputtext {
    border-radius: 8px;
    border: 0rem;
    color: #2e353d;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }
  .inputForms .p-inputtext.p-invalid {
    border: 1rem solid #f44336;
  }
  .inputForms label {
    color: #2e353d;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }
  .inputForms .multi-select-with-height {
    align-items: center;
    display: flex;
    font-family: Montserrat;
    height: 5rem;
    width: 46.6rem;
  }
  .inputForms .height-width-users {
    height: 5rem;
    width: 25.6rem;
  }
`;
interface ISearchButtonFilter {
  isLoading?: any;
}
export const SearchButtonFilter = styled.button<ISearchButtonFilter>`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 0.8rem;
  border: none;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-left: 0.5rem;
  width: 5rem;

  .icon-vector-img {
    height: 1.5rem;
    margin-left: 1.8rem;
    width: 1rem;
  }
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

interface IInputElement {
  hasError?: any;
  disableOutline?: any;
}
export const InputElement = styled.input<IInputElement>`
  ${(props) => `
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "4.5rem"};
    outline: ${props.disableOutline ? "none" : ""};
    width: ${props.width};
  `}

  border-radius: 0.8rem;
  box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  font-size: 1.5rem;
  font-weight: 500;
  padding-left: 1.5rem;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;

export const MainButton = styled.button`
  ${(props) => `
  background-color: ${props.theme.colors.accentGreen};
  font-family: ${props.theme.fontFamilies.primaryFont};
`}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  font-weight: 700;
  justify-content: center;
  min-height: 6.4rem;
  width: 25.6rem;
  .icon {
    height: 5rem;
    width: 5rem;
    margin-left: 1rem;
  }
  .icon-right {
    height: 1.2rem;
    width: 0.8rem;
    margin-left: 1rem;
  }
`;

export const VolanteId = styled.div`
  ${(props) => `
    color: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.4rem;
  font-weight: 600;
`;

export const DivTable = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  .tableSearch .TableBody tr.trBody {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
    height: 6.1rem;
  }
  .tableSearch thead th {
    color: #989ca2;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: bold;
    line-height: 1.5rem;
  }
  .tableSearch .TableBody tr.trBody td {
    border: hidden;
    color: #08082b;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.7rem;
  }
  .tableSearch .TableBody tr.trBody .ellipsis-text {
    overflow: hidden;
  }
  .tableSeparate {
    border-collapse: separate !important;
    border-spacing: 0 0.8rem;
  }
  .tableSearch .between-flex {
    display: flex;
    justify-content: space-between;
  }

  .width-flex-left {
    display: flex;
    margin-left: 2rem;
    width: 100%;
  }
  .width-left {
    margin-left: 2rem;
    width: 100%;
  }
  .tableSearch .between-flex-center {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  .width-flex {
    display: flex;
    width: 100%;
  }
  .width-option-styles {
    width: 35rem;
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
  }
  .flex-with-rem {
    display: flex;
    justify-content: flex-end;
    margin-right: 2rem;
    width: 35rem;
  }
  .table-margin-top {
    margin-top: 3.2rem;
    width: 100%;
  }
`;

export const DivFleDirection = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IDivMarginTop {
  marginTop?: string;
}
export const DivMarginTop = styled.div<IDivMarginTop>`
  ${(props) => `
    margin-top: ${props.marginTop ? props.marginTop : "3.2rem"};
  `}
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 2rem;
  .justify-end-div {
    display: flex;
    justify-content: flex-end;
  }
  .paginator-class .p-paginator-page {
    background: #002e6c;
    color: #ffffff;
  }
  @media (max-width: 480px) {
    justify-content: center;
  }
`;

export const DivPaginator = styled.div`
  ${(props) => `
    background: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: #FFFFFF;
  font-size: 1.5rem;
`;

export const Container = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 5rem 3.2rem 1.2rem;
  width: 116.8rem;

  .header {
    flex-shrink: 0;
    order: 1;
  }
  .content {
    order: 2;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .footer {
    flex-shrink: 0;
    order: 3;

    .block-hint {
      color: ${(props) => props.theme.colors.red};
      font-size: 1.4rem;
      text-align: center;
    }
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const DivCompany = styled.div`
  color: #2e353d;
  font-size: 1.4rem;
  margin-top: 4rem;
`;

export const ContentDiv = styled.div`
  align-items: center;
  display: grid;
  font-family: Montserrat;
  font-size: 1.3rem;
  grid-template-columns: 1fr 13rem 13rem;
  justify-content: space-between;
  margin-left: 1.1rem;
  margin-right: 1.1rem;

  .option-flex-align {
    display: flex;
    width: 20rem;
    align-items: center;
  }
`;

export const DivFlexCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const DivLine = styled.div`
  background: rgba(231, 231, 234, 0.74);
  height: 1px;
  margin-top: 1.6rem;
  width: 28.2rem;
`;

interface IButton {
  status?: string;
}
export const Button = styled.button<IButton>`
  ${(props) => `
    background-color: ${
      props.status === "accept"
        ? props.theme.colors.primaryBlue
        : props.status === "confirm"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    border: ${
      props.status === "cancel"
        ? `1px solid ${props.theme.colors.accentRed}`
        : "none"
    };
    color: ${
      props.status === "cancel"
        ? props.theme.colors.accentRed
        : props.theme.colors.white
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
    
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 1rem;
  width: 100%;

  .icon {
    height: 5rem;
    width: 5rem;
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
`;

export const Container1 = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  min-height: 23rem;
  padding: 4rem 5rem;
  text-align: center;
  width: 40rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0;
  }

  .button-container {
    width: 100%;
  }

  .description {
    ${(props) => `
      color: ${props.theme.colors.gray};
    `}
    font-size: 1.5rem;
  }

  .icon {
    height: 6rem;
    margin: 1rem;
    width: 6rem;
  }
`;

export const Headers = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainContainer = styled.div`
  padding-top: 3rem;
`;

interface IDivUserType {
  typeUser?: string;
}
export const DivUserType = styled.div<IDivUserType>`
  ${(props) => `
      color: ${props.typeUser === "Administrador" ? "#989CA2" : "#000000"};
    `}
  margin-left: 1.4rem;
  font-size: 1.4rem;
  font-family: Montserrat;
`;

interface IContainerProfile {
  profilesLength: boolean;
}

export const ContainerProfile = styled.div<IContainerProfile>`
  ${(props) => `
  width: ${props.profilesLength && "33vw"};
  @media (max-width: 750px) {
    width: 50rem !important;
  }
`}
`;

export const MenuContainerUser = styled.div`
  align-items: flex-end !important;
  display: flex;
  justify-content: center;
  width: 100%;
  @media (max-width: 750px) {
    align-items: center !important;
  }
`;

export const DivOverMaxHeigthIntra = styled.div`
  max-height: 58vh;
  overflow-x: hidden;
  overflow-y: auto;

  @media (max-height: 400px) {
    max-height: 45vh;
  }
`;
